module.exports = __webpack_public_path__ + "static/media/Cuida.60be158c.svg";